import * as Sentry from "@sentry/browser";
import { EventManager } from "../main/utils/event.js";
import { gettext } from "../main/utils/i18n.js";
const sentryConfig = { ...window._APP_.sentry };
const member = sentryConfig.member;
if (member) {
    delete sentryConfig.member;
    Sentry.setUser({
        id: member.id,
        name: member.name,
        email: member.email,
    });
}
const feedback = Sentry.feedbackIntegration({
    autoInject: false,
    showBranding: false,
    showName: false,
    showEmail: false,
    useSentryUser: {
        name: "name",
        email: "email",
    },
    formTitle: gettext("Report an error"),
    submitButtonLabel: gettext("Send"),
    cancelButtonLabel: gettext("Cancel"),
    confirmButtonLabel: gettext("Confirm"),
    addScreenshotButtonLabel: gettext("Add screenshot"),
    removeScreenshotButtonLabel: gettext("Remove screenshot"),
    isRequiredLabel: gettext("(required)"),
    messageLabel: gettext("Description"),
    messagePlaceholder: gettext("Describe the error. What did you expect?"),
    successMessageText: gettext("Thank you for your feedback!"),
});
async function openFeedbackForm() {
    const form = await feedback.createForm();
    form.appendToDom();
    form.open();
}
const ev = new EventManager();
ev.onGlobal("click", openFeedbackForm, {
    delegate: "[user-feedback-trigger]",
});
Sentry.init({
    ...sentryConfig,
    integrations: [
        Sentry.browserTracingIntegration(),
        // Sentry.replayIntegration({
        //   maskAllText: false,
        //   maskAllInputs: false,
        //   networkDetailAllowUrls: [window.location.origin],
        //   networkRequestHeaders: ["Rerender"],
        //   networkResponseHeaders: ["Rerender"],
        // }),
    ],
});
//# sourceMappingURL=main.js.map